import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon, ClockIcon, ChevronRightIcon, MapPinIcon, InfoIcon } from 'lucide-react';
export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <>
      {/* Top Bar with Contact Info */}
      <div className="hidden lg:block bg-gradient-to-r from-[#0a0a0a] via-black to-[#0a0a0a] border-b border-white/5 py-2" data-id="element-322">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-12 flex justify-between items-center" data-id="element-323">
          <div className="flex items-center space-x-6" data-id="element-324">
            <div className="flex items-center text-white/70 hover:text-white transition-colors duration-300" data-id="element-325">
              <PhoneIcon size={14} className="mr-2 text-[#D6281F]" data-id="element-326" />
              <a href="tel:+31627888306" className="text-sm font-medium" data-id="element-327">
                +31 (0)6 278 88 306
              </a>
            </div>
            <div className="flex items-center text-white/70 hover:text-white transition-colors duration-300" data-id="element-328">
              <ClockIcon size={14} className="mr-2 text-[#D6281F]" data-id="element-329" />
              <span className="text-sm font-medium" data-id="element-330">
                Ma-Za: 08:00-19:30 | Zo: Op afspraak
              </span>
            </div>
            <div className="flex items-center text-white/70 hover:text-white transition-colors duration-300" data-id="element-331">
              <MapPinIcon size={14} className="mr-2 text-[#D6281F]" data-id="element-332" />
              <span className="text-sm font-medium" data-id="element-333">
                Microfoonstraat 36, Almere
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-334">
            <a href="https://www.instagram.com/bk.customs36/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white text-sm font-medium transition-colors duration-300 hover-underline-animation" aria-label="Instagram" data-id="element-335">
              Instagram
            </a>
            <a href="https://www.tiktok.com/@bk.customs36" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white text-sm font-medium transition-colors duration-300 hover-underline-animation" aria-label="TikTok" data-id="element-336">
              TikTok
            </a>
          </div>
        </div>
      </div>
      {/* Main Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-black/90 backdrop-blur-xl py-3 shadow-2xl border-b border-[#222]' : 'bg-transparent py-5 lg:mt-10'}`} data-id="element-337">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-12" data-id="element-338">
          <div className="flex items-center justify-between" data-id="element-339">
            {/* Logo */}
            <Link to="/" className="relative z-10 flex-shrink-0 group" data-id="element-340">
              <div className="overflow-hidden rounded-sm bg-gradient-to-br from-black to-[#0a0a0a] p-1 shadow-2xl border border-white/5" data-id="element-341">
                <div className="relative flex items-center" data-id="element-342">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6P9doWbYb8UgxtfPvK6o5M/BK-Customs-Logo-DEF-01-1973x2048.png" alt="BKCustoms Logo" className="h-16 w-auto transition-transform duration-500 group-hover:scale-105" data-id="element-343" />
                  <div className="ml-3 hidden lg:block border-l border-white/10 pl-3" data-id="element-344">
                    <div className="text-xs uppercase tracking-widest text-white/70" data-id="element-345">
                      AUTO STYLING ALMERE
                    </div>
                    <div className="text-sm font-semibold tracking-wide text-white" data-id="element-346">
                      BKCustoms{' '}
                      <span className="text-[#D6281F]" data-id="element-347">since 2020</span>
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-r from-[#D6281F]/0 via-white/10 to-[#D6281F]/0 opacity-0 group-hover:opacity-100 -translate-x-full group-hover:translate-x-full transition-all duration-1000 ease-in-out" data-id="element-348"></div>
                </div>
              </div>
            </Link>
            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center" data-id="element-349">
              <div className="bg-[#0a0a0a]/80 backdrop-blur-sm border border-white/5 rounded-full py-2 px-1 mr-6" data-id="element-350">
                <ul className="flex items-center space-x-1" data-id="element-351">
                  {[{
                  name: 'HOME',
                  href: '/'
                }, {
                  name: 'DIENSTEN',
                  href: '/diensten'
                }, {
                  name: 'OVER ONS',
                  href: '/over-ons'
                }, {
                  name: 'PORTFOLIO',
                  href: '/#portfolio'
                }, {
                  name: 'REVIEWS',
                  href: 'https://www.google.com/search?sxsrf=AE3TifNiNevh4m__DdaKWERCMdH24XpRtg:1754766584748&uds=AOm0WdE2fekQnsyfYEw8JPYozOKz0wcvbhHSVFg8j-5t32_cmw-uZHH1Ie0ViIzu2Ih2Lf2im8v8fY1Ho2TGkJfJRJpAGhY55Xpv1IbzirtlLVC2Vh8ZGmLH0P_oWVzAAxnUGFjdyEzDGqU8E6Wv5m5gwuUD1jNCdQ&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-EznTpCXA5n6GCKlFSNsSFTRFdddxfZT0txeh7NrTgp9y_tTxUR9AZDv4TVb9CBJAr3216lk%3D&q=Bk+Customs+Reviews',
                  external: true
                }].map(item => <li key={item.name} data-id="element-352">
                      {item.external ? <a href={item.href} target="_blank" rel="noopener noreferrer" className="relative group px-4 py-2 block rounded-full hover:bg-white/5 transition-colors duration-300" data-id="element-353">
                          <span className="relative z-10 text-white text-sm font-semibold tracking-wide transition-colors duration-300 group-hover:text-[#D6281F]" data-id="element-354">
                            {item.name}
                          </span>
                        </a> : <Link to={item.href} className="relative group px-4 py-2 block rounded-full hover:bg-white/5 transition-colors duration-300" data-id="element-355">
                          <span className="relative z-10 text-white text-sm font-semibold tracking-wide transition-colors duration-300 group-hover:text-[#D6281F]" data-id="element-356">
                            {item.name}
                          </span>
                        </Link>}
                    </li>)}
                </ul>
              </div>
              {/* Refined CTA Button - Less Bold */}
              <Link to="/afspraak-maken" className="relative overflow-hidden group" data-id="element-357">
                <div className="absolute inset-0 bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] rounded-md opacity-80 animate-gradient-shift" data-id="element-358"></div>
                <div className="relative flex items-center justify-center px-6 py-3 rounded-md" data-id="element-359">
                  <span className="text-black font-medium tracking-wide uppercase mr-2 transition-all duration-300 group-hover:translate-x-[-2px] text-sm" data-id="element-360">
                    Afspraak maken
                  </span>
                  <ChevronRightIcon size={14} className="text-black transition-all duration-300 group-hover:translate-x-1" data-id="element-361" />
                </div>
              </Link>
            </div>
            {/* Mobile Menu Button */}
            <div className="lg:hidden" data-id="element-362">
              <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="relative p-2 overflow-hidden group" aria-expanded={isMenuOpen} data-id="element-363">
                <div className="absolute inset-0 bg-[#D6281F]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-sm" data-id="element-364"></div>
                <div className="relative z-10" data-id="element-365">
                  {isMenuOpen ? <XIcon size={24} className="text-white" data-id="element-366" /> : <MenuIcon size={24} className="text-white" data-id="element-367" />}
                </div>
              </button>
            </div>
          </div>
        </div>
        {/* Mobile Menu */}
        {isMenuOpen && <div className="lg:hidden bg-black/95 backdrop-blur-xl animate-fadeIn" data-id="element-368">
            <div className="px-6 pt-6 pb-8 divide-y divide-white/10" data-id="element-369">
              <div className="pb-6 space-y-4" data-id="element-370">
                {[{
              name: 'HOME',
              path: '/',
              external: false
            }, {
              name: 'DIENSTEN',
              path: '/diensten',
              external: false
            }, {
              name: 'OVER ONS',
              path: '/over-ons',
              external: false
            }, {
              name: 'PORTFOLIO',
              path: '/#portfolio',
              external: false
            }, {
              name: 'REVIEWS',
              path: 'https://www.google.com/search?sxsrf=AE3TifNiNevh4m__DdaKWERCMdH24XpRtg:1754766584748&uds=AOm0WdE2fekQnsyfYEw8JPYozOKz0wcvbhHSVFg8j-5t32_cmw-uZHH1Ie0ViIzu2Ih2Lf2im8v8fY1Ho2TGkJfJRJpAGhY55Xpv1IbzirtlLVC2Vh8ZGmLH0P_oWVzAAxnUGFjdyEzDGqU8E6Wv5m5gwuUD1jNCdQ&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-EznTpCXA5n6GCKlFSNsSFTRFdddxfZT0txeh7NrTgp9y_tTxUR9AZDv4TVb9CBJAr3216lk%3D&q=Bk+Customs+Reviews',
              external: true
            }].map(item => item.external ? <a key={item.name} href={item.path} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between text-white py-2 border-b border-white/10 hover:text-[#D6281F] transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-371">
                      <span className="text-base font-medium" data-id="element-372">{item.name}</span>
                      <ChevronRightIcon size={16} data-id="element-373" />
                    </a> : <Link key={item.name} to={item.path} className="flex items-center justify-between text-white py-2 border-b border-white/10 hover:text-[#D6281F] transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-374">
                      <span className="text-base font-medium" data-id="element-375">{item.name}</span>
                      <ChevronRightIcon size={16} data-id="element-376" />
                    </Link>)}
              </div>
              <div className="pt-6 space-y-4" data-id="element-377">
                <div className="flex items-center text-white/70" data-id="element-378">
                  <PhoneIcon size={16} className="mr-3 text-[#D6281F]" data-id="element-379" />
                  <a href="tel:+31627888306" className="text-sm hover:text-white transition-colors duration-300" data-id="element-380">
                    +31 (0)6 278 88 306
                  </a>
                </div>
                <div className="flex items-center text-white/70" data-id="element-381">
                  <ClockIcon size={16} className="mr-3 text-[#D6281F]" data-id="element-382" />
                  <span className="text-sm" data-id="element-383">Ma-Za: 08:00-19:30</span>
                </div>
                <div className="flex items-center text-white/70" data-id="element-384">
                  <MapPinIcon size={16} className="mr-3 text-[#D6281F]" data-id="element-385" />
                  <span className="text-sm" data-id="element-386">Microfoonstraat 36, Almere</span>
                </div>
                {/* Refined Mobile CTA Button */}
                <Link to="/afspraak-maken" className="block relative overflow-hidden mt-4" onClick={() => setIsMenuOpen(false)} data-id="element-387">
                  <div className="bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] animate-gradient-shift px-6 py-3 text-center font-medium uppercase tracking-wide text-black rounded-md opacity-90" data-id="element-388">
                    Afspraak maken
                  </div>
                </Link>
              </div>
            </div>
          </div>}
      </nav>
    </>;
};